import {Component, Input, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {BoardService} from "../../../service/board/board.service";
import {CommunityBoardPage} from "../../../service/board/board";
import {GtmService} from "../../../service/gtm/gtm.service";

@Component({
  selector: 'app-community-list',
  templateUrl: './community-list.component.html',
  styleUrls: ['./community-list.component.scss'],
  providers: [BoardService]
})
export class CommunityListComponent implements OnInit {
  @Input() mine: boolean = false;

  page: number;
  location: string;
  search: string;
  category: string;
  tag: string;
  active: string;

  boards: CommunityBoardPage;

  constructor(private boardService: BoardService,
              private router: Router,
              private route: ActivatedRoute,
              private gtmService: GtmService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(
      params => {
        this.page     = params['page']      ? +params['page']    : 1;
        this.location = params['location']  ? params['location'] : '';
        this.search   = params['search']    ? params['search']   : '';
        this.category = params['category']  ? params['category'] : '';
        this.tag      = params['tag']       ? params['tag']      : '';
        this.active   = params['active']    ? params['active']   : '';

        this.getBoard();

        if (!this.mine) {
          this.gtmService.pageViewWithPage({
            'path': this.route.snapshot['_routerState'].url,
            'title': 'Community',
            'breadcrumb': 'Home > Member > Community'
          });
        }
      }
    );
  }

  getBoard() {
    this.boardService.getsByCommunity(this.page, this.location, this.search, this.category, this.tag, this.active, this.mine).subscribe(
      boards => {
        // console.log(boards)
        this.boards = boards
      }
    );
  }

  reload(page: number) {
    let url = this.router.url.split('?')[0];

    this.router.navigateByUrl(
      `${url}?page=${page}`+
      `${this.location ? `&location=${this.location}`: ''}`+
      `${this.search ? `&search=${this.search}`: ''}`+
      `${this.category ? `&category=${this.category}`: ''}`+
      `${this.tag ? `&tag=${this.tag}`: ''}`+
      `${this.active ? `&active=${this.active}`: ''}`
      );
  }

  onPageChanged(event: any) {
    if (event.page == this.page) return;
    this.reload(event.page);
  }
}



// WEBPACK FOOTER //
// ./src/app/member/community-board/community-list/community-list.component.ts